import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
//api
import { createPost } from 'api/blog';
//components
import Title from 'components/backoffice/texts/title';
import PostsForm from 'components/backoffice/forms/postsForm';

const CreatePost = () => {
  const { t } = useTranslation(['backoffice']);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { setTitle } = useOutletContext()

  const post = {
    title: '',
    body: '',
    featured_paragraph: '',
    status: '',
    category: '',
    featured_image: undefined
  }

  useEffect(() => {
    setTitle(t('createpost'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  const onSubmit = useCallback(async (values) => {
    setLoading(true)
    const data = {
      title: values.title,
      body: values.body,
      featured_paragraph: values.featured_paragraph,
      featured_image: values.featured_image,
      status: values.status,
      category: values.category,
    };

    try {
      const { status } = await createPost(data);
      if (status === 201) {
        toast.success(t('creadocorrectamente'));
        navigate('/intranet/posts', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false)
  }, []);

  return (
    <div className="post-create mt-5">
      <Title text={t('createpost')} />
      <PostsForm
        loading={loading}
        isEditing={false}
        onSubmitForm={onSubmit}
        defaultValues={post}
        fileInputRef={fileInputRef}
        beforeTitle={t('createpost')}
      />
    </div>
  );
};

export default CreatePost;
